import React from "react";
import {
  getDeferredPrompt,
  isIframeDeployment,
  isPwaInstalled,
  triggerPwaInstall,
} from "../../../Actions/Utils";
import {
  pwaInstallAddToHomeScreen,
  pwaInstallButton,
} from "../../../NewConstants/PwaInstallConstants";

const PwaInstallBanner = ({ selectedLanguage }) => {
  if (isPwaInstalled() || !getDeferredPrompt() || isIframeDeployment()) {
    return null;
  }

  return (
    <div className="flex justify-between items-center w-full z-20 p-2 bg-[var(--light-neutral-14)]">
      <p className="font-semibold text-[var(--primary-dark)] text-[16px]">
        {pwaInstallAddToHomeScreen[selectedLanguage]}
      </p>
      <button
        onClick={triggerPwaInstall}
        className="font-semibold text-[14px] flex items-center justify-center rounded-[8px] border border-[0.83px] px-[16px] py-[10px] opacity-100 bg-[var(--primary-dark)] text-white"
      >
        {pwaInstallButton[selectedLanguage]}
      </button>
    </div>
  );
};

export default PwaInstallBanner;
